import reportIcon from "components/icons/DangerTriangle.svg";
import hideIcon from "components/icons/eye.svg";
// import addIcon from "components/icons/FolderAdd2.svg";
import shareIcon from "components/icons/share-red.svg";
import collectionIcon from "components/icons/bookmark.svg";
import embedIcon from "../icons/embed_desktop.svg";
import linkIcon from "../icons/link_desktop.svg";
import RedditIcon from "../icons/reddit_desktop.svg";
import TwitterIcon from "../icons/twitter_desktop.svg";
import DiscordIcon from "../icons/discord_desktop.svg";
import manageIcon from "components/icons/manage_icon.svg";
import GearIcon from "components/icons/gear.svg";

export const getMoreMenuData = ({ actions, currentUser, gif }: any) => {
  const {
    onHide,
    onManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    toggleChangeNichesDialog,
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = gif.userName === currentUser?.username;

  return [
    {
      groupName: null,
      groupMobileName: "Options",
      items: [
        {
          icon: shareIcon,
          title: "Share",
          onClick: toggleShareMenu
        },
        // ...(isAuth ? [{
        //   icon: addIcon,
        //   title: "Add to a niche",
        //   onClick: toggleNiche
        // }] : []),
        ...(isAuth ? [{
          icon: collectionIcon,
          title: "Add to a collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: reportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isCM ? [{
          icon: hideIcon,
          title: "Hide",
          onClick: onHide
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change niches",
          onClick: toggleChangeNichesDialog,
        }] : []),
        ...(isThisUserGif ? [{
          icon: manageIcon,
          title: "Manage",
          onClick: onManageClick,
        }] : []),
      ]
    }
  ];
};

export const getShareMenuData = (onShareClick: any) => {
  return [
    {
      groupName: null,
      groupMobileName: "Share:",
      items: [
        {
          icon: linkIcon,
          title: "Copy Link",
          onClick: () => onShareClick("Copy Link")
        },
        {
          icon: embedIcon,
          title: "Embed",
          onClick: () => onShareClick("Embed")
        }
      ]
    },
    {
      groupName: "Social Share:",
      groupMobileName: "Social Share:",
      items: [
        {
          icon: RedditIcon,
          title: "Reddit",
          onClick: () => onShareClick("Reddit")
        },
        {
          icon: TwitterIcon,
          title: "Twitter",
          onClick: () => onShareClick("Twitter")
        },
        {
          icon: DiscordIcon,
          title: "Discord",
          onClick: () => onShareClick("Discord")
        }
      ]
    }
  ];
};

export const getShareLink = (gif: any) => `https://www.redgifs.com/watch/${gif.id}`;

export const getRedditLink = (gif: any) => {
  const type = gif.type !== 1 ? "image" : "GIF";
  const userName = gif.userName ?? null;
  const tags = gif.tags || [];
  let shareLink = getShareLink(gif);
  let title = "Please come up with a description...";

  if (tags.length > 0 && userName) {
    title = `${tags[0]} ${type} by ${userName}`;
  } else if (tags.length > 0) {
    title = `${tags[0]} ${type}`;
  } else if (userName) {
    title = `A porn ${type} by ${userName}`;
  }

  if (gif.type !== 1) {
    shareLink = `https://i.redgifs.com/i/${gif.id}.jpg`;
  }

  return `https://www.reddit.com/submit?url=${encodeURIComponent(shareLink)}&title=${title}`;
};
